
    // this file was auto generated by python script
    import Inbox from './Inbox';
    export default Inbox;
    